import r from "../../deserializes/hook/useMakeSeason.js";
import s from "../../../temp-lib/config/index.js";
import n from "../../../temp-lib/hooks/json/useReactQueryFetchJson.js";
const m = (e) => {
  const {
    fetchNow: o
  } = e || {}, {
    makeCurrentSeason: t
  } = r();
  return n({
    fetchNow: o,
    path: s.JSON_FILE_NAME.CURRENT_SEASON,
    deserialize: t
  });
};
export {
  m as default
};
//# sourceMappingURL=useFetchCurrentSeasonJson.js.map
